import makeClick from "@analytics/clickFactory";
import makePageLoad from "@analytics/pageLoadFactory";

// Glossary config is nested per page, so each event picks its own fields.
const click = makeClick();
const pageLoad = makePageLoad();

export const glossaryLandingPageLoaded = (pageLoadAnalytics) => {
  if (pageLoadAnalytics) {
    pageLoad({
      tag: pageLoadAnalytics.tagId,
      section: pageLoadAnalytics.section,
      subsection: pageLoadAnalytics.landingPage?.subSection,
      page: pageLoadAnalytics.landingPage?.page,
    });
  }
};

export const glossaryResultsPageLoaded = (pageLoadAnalytics, page) => {
  if (pageLoadAnalytics) {
    pageLoad({
      tag: pageLoadAnalytics.tagId,
      section: pageLoadAnalytics.section,
      page,
    });
  }
};

export const glossaryNoResultsPageLoaded = (
  pageLoadAnalytics,
  page,
  keyword,
) => {
  if (pageLoadAnalytics) {
    pageLoad({
      tag: pageLoadAnalytics.tagId,
      section: pageLoadAnalytics.section,
      page,
      keyword,
      numberOfSearchResults: "0",
    });
  }
};

export const modalLoaded = (pageLoadAnalytics) => {
  if (pageLoadAnalytics) {
    pageLoad({
      tag: pageLoadAnalytics.results?.tagId,
      section: pageLoadAnalytics.section,
      page: pageLoadAnalytics.imageModal?.page,
    });
  }
};

const glossaryClick = (clickAnalytics, fields) => {
  click({
    tag: clickAnalytics?.tagId,
    container: clickAnalytics?.container,
    ...fields,
  });
};

export const headerLinkClick = (
  clickAnalytics,
  category,
  positionTitle,
  label,
) => {
  glossaryClick(clickAnalytics, { category, positionTitle, label });
};

export const searchLinkClick = (
  clickAnalytics,
  category,
  positionTitle,
  label,
  keyword,
) => {
  glossaryClick(clickAnalytics, { category, positionTitle, label, keyword });
};

export const accordionLinkClick = (
  clickAnalytics,
  category,
  label,
  keyword,
) => {
  glossaryClick(clickAnalytics, { category, label, keyword });
};

export const termLinkClick = (
  clickAnalytics,
  category,
  positionTitle,
  label,
) => {
  glossaryClick(clickAnalytics, { category, positionTitle, label });
};

export const resultsLinkClick = (clickAnalytics, category, label, keyword) => {
  glossaryClick(clickAnalytics, { category, label, keyword });
};

export const modalLinkClick = (clickAnalytics, category, label) => {
  glossaryClick(clickAnalytics, { category, label });
};

export const glossaryContactFormSubmit = (clickAnalytics, category) => {
  glossaryClick(clickAnalytics, { category, label: clickAnalytics?.label });
};

const overlayClick = (clickAnalytics, fields) => {
  click({
    tag: clickAnalytics?.tagId,
    container: clickAnalytics?.glossaryOverlay?.container,
    ...fields,
  });
};

export const glossaryOverlayOnLoad = (
  clickAnalytics,
  category,
  contentTitle,
) => {
  overlayClick(clickAnalytics, {
    label: clickAnalytics?.glossaryOverlay?.openLabel,
    category,
    contentTitle,
  });
};

export const glossaryOverlayCtaClick = (
  clickAnalytics,
  category,
  label,
  contentTitle,
) => {
  overlayClick(clickAnalytics, { category, label, contentTitle });
};

export const glossaryOverlayClose = (
  clickAnalytics,
  category,
  contentTitle,
) => {
  overlayClick(clickAnalytics, {
    label: clickAnalytics?.glossaryOverlay?.closeLabel,
    category,
    contentTitle,
  });
};
